import AISettings from './AISettings';

export default AISettings;
